import { motion } from "framer-motion";
import { BUSINESS } from "../../data/content";

const ITEMS = [
  { big: "Class A", small: "Air Conditioning Contractor" },
  { big: BUSINESS.license, small: "Florida Contractor License" },
  { big: "Residential", small: "Home Comfort Solutions" },
  { big: "Commercial", small: "Business HVAC Solutions" },
];

export const TrustStrip = () => {
  return (
    <div data-testid="trust-strip" className="bg-fc-orange text-white">
      <div className="mx-auto w-[92%] max-w-[1280px] grid grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.small}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className={`px-6 py-6 ${i < 3 ? "lg:border-r border-white/25" : ""} ${i % 2 === 0 ? "border-r border-white/25 lg:border-r" : ""} ${i < 2 ? "border-b border-white/25 lg:border-b-0" : ""}`}
          >
            <div className="font-display text-lg font-semibold leading-tight">{it.big}</div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/85 mt-1">{it.small}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
